// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qcgnklqgyzwvjrmhzwfj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFjZ25rbHFneXp3dmpybWh6d2ZqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQwNzg4MjksImV4cCI6MjA1OTY1NDgyOX0.wtoW6gw37fmGmidL5lKwJXxygUZucH2P_4BpwS4YvOU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);